import { a11yClick } from './util';

(function(Drupal, $, once) {
  'use strict';

  const minFontSize = 16;
  const maxFontSize = 18;
  const limitClass = 'limit';

  let currentSize = null;
  let $html, $increaseSizeBtn, $reduceSizeBtn;

  // Take jquery object, return font size converted to int.
  const getFontSizeInt = ($elem) => {
    return parseInt($elem.css('font-size'), 10);
  }


  // Called from font size adjust buttons.
  const adjustFontSize = (direction) => {
    if (currentSize != null) {
      if (direction === 'down') {
        if (currentSize > minFontSize) {
          currentSize--;
        }
      }
      else if (direction === 'up') {
        if (currentSize < maxFontSize) {
          currentSize++;
        }
      }
    }

    // Update actual site base font size.
    $html.css('font-size', currentSize + 'px');
  };

  // Set limit class state based on currentSize
  const checkSizeLimit = () => {
    if (currentSize > minFontSize) {
      $reduceSizeBtn.removeClass(limitClass);
    }
    else {
      $reduceSizeBtn.addClass(limitClass);
    }

    if (currentSize < maxFontSize) {
      $increaseSizeBtn.removeClass(limitClass);
    }
    else {
      $increaseSizeBtn.addClass(limitClass);
    }
  };

  Drupal.behaviors.fontSizeAdjust = {
    attach: function(context, settings) {

      $(once('font-size-adjust', 'html', context)).each(function() {

        $html = jQuery(this);

        let $fontSizeAdjustWrapper = jQuery(this).find('#fontSizeAdjust');
        $reduceSizeBtn = $fontSizeAdjustWrapper.find('#reduceSize');
        $increaseSizeBtn = $fontSizeAdjustWrapper.find('#increaseSize');

        currentSize = getFontSizeInt($html);

        checkSizeLimit();

        $reduceSizeBtn.click(function(event) {
          event.preventDefault();

          if (a11yClick(event) === true) {
            adjustFontSize('down');
            checkSizeLimit();
          }
        });

        $increaseSizeBtn.click(function(event) {
          event.preventDefault();

          if (a11yClick(event) === true) {
            adjustFontSize('up');
            checkSizeLimit();
          }
        });
      });
    }
  };

})(Drupal, jQuery, once);
